export default {
  dashboard: state => state.dashboard,
  dashboardBreakout: state => state.dashboardBreakout,
  dashboardTop3: state => state.dashboardTop3,
  dashboardTop: state => state.dashboardTop,
  dashboardProfit: state => state.dashboardProfit,
  dashboardCycleTimes: state => state.dashboardCycleTimes,
  dashboardTrend: state => state.dashboardTrend,
  dashboardView: state => state.dashboardView,
  startDate: state => state.startDate,
  endDate: state => state.endDate,
  invoiceView: state => state.invoiceView,
  invoiceFirm: state => state.invoiceFirm,
  analyzeView: state => state.analyzeView,
  analyzeViews: state => state.analyzeViews,
  rangeView: state => state.rangeView,
  rangeViews: state => state.rangeViews,
  payroll: state => state.payroll,
  techData: state => state.techData,
  payments: state => state.payments
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/getters.js